/**
 * Identidade da loja no papel timbrado da OS.
 *
 * Fica num lugar só porque é conteúdo que muda por motivo de negócio — mudança
 * de endereço, novo telefone, texto de garantia revisado — e não por motivo de
 * software. Trocar aqui muda o cabeçalho de todo documento impresso.
 *
 * Os campos opcionais nascem vazios de propósito: um papel entregue ao cliente
 * não pode carregar endereço ou CNPJ inventado. Cada um só aparece na folha
 * depois de preenchido aqui.
 */
export interface IdentidadeLoja {
  nome: string;
  /** Linha de apoio sob o nome, no cabeçalho. */
  atividade: string;
  /** Caminho do logo em `public/`. */
  logo: string;
  endereco: string;
  telefone: string;
  cnpj: string;
  site: string;
  /** Texto legal no rodapé — garantia, prazo de retirada. Vazio: não sai. */
  termos: string;
}

export const LOJA: IdentidadeLoja = {
  nome: 'Leão de Judá Informática',
  atividade: 'Assistência técnica em informática e eletrônicos',
  logo: '/ico.png',
  endereco: '',
  telefone: '',
  cnpj: '',
  site: '',
  termos: '',
};
